module.exports = __webpack_public_path__ + "ad4b71c665a719894c91351e648a3542.MP3";